import { CallApi, handleJSONResponse } from "./common";
import { AdminGetSummaryResponse } from "../../../../services/earnings/types/api/admin-get-summary-response";
import { EarningsSummary } from "../../../../services/earnings/types/earnings-summary";
import DineroFactory from "dinero.js";
import { EarningsOwnerType } from "../../../../services/earnings/types/earnings-owner-type";

const callAPI = CallApi("earnings/admin");

export const getEarningsSummary = async (
  userId: string,
  type: EarningsOwnerType = "OWNER"
): Promise<EarningsSummary[]> => {
  const response = await callAPI(`/summary/${type}/${userId}`, "GET");

  const summary: AdminGetSummaryResponse = await handleJSONResponse(response);

  return summary.map((item) => ({
    ...item,
    value: DineroFactory(item.value),
  }));
};

export const prioritizeArtist = async (
  artistId: string
): Promise<{
  isPriorityArtist: boolean;
}> => {
  const response = await callAPI(`/priority-artist`, "POST", { artistId });
  return handleJSONResponse(response);
};

export const checkPriorityArtist = async (
  artistId: string
): Promise<{
  isPriorityArtist: boolean;
}> => {
  const response = await callAPI(`/priority-artist/${artistId}`, "GET");
  return handleJSONResponse(response);
};

